import { useSmartProp } from '@smartfire/glue-ui/block';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';

export const Inspector = () => {
    const [linkMore, setLinkMore] = useSmartProp('linkMore');
    return (
        <PanelBody title="Lien 'En savoir plus'">
            <PanelRow>
                <TextControl value={linkMore} onChange={setLinkMore} />
            </PanelRow>
        </PanelBody>
    );
};
